import { DomainContext } from "hhn-commons";
import { Navigate, Route, Routes, useLocation } from "react-router";
import { SocketConnectionErrorHandler } from "./connection/SocketConnectionErrorHandler";
import Loader from "./loader/Loader";
import NotFound from "./notFound/NotFound";
import Organizations from "./organization/Organizations";
import { ROUTES } from "./routes";
import { storePendingRoute } from "./utils/pendingRouteStorage";
import { usePendingRouteRedirect } from "./utils/usePendingRouteRedirect";
import { useContext } from "react";

export const Auth = () => {
  const { domain } = useContext(DomainContext);
  const location = useLocation();

  // Gate on the domain so this decision and Organizations.tsx's
  // domain-unknown loader flip at the same moment — avoids the two-loader
  // flicker that happened when this branch was driven by SessionManager
  // state (which flips earlier than the domain transition).
  if (domain.domainType === "unknown") return <Loader />;

  if (!domain.isUserLoggedIn()) {
    const intendedRoute = location.pathname + location.search;
    if (location.pathname !== "/") storePendingRoute(intendedRoute);
    return <Navigate to={ROUTES.LOGIN} replace={true} />;
  }

  return (
    <SocketConnectionErrorHandler>
      <Authenticated />
    </SocketConnectionErrorHandler>
  );
};

function Authenticated() {
  const { pathname } = useLocation();
  const pendingRoute = usePendingRouteRedirect(pathname);

  if (pendingRoute) return <Navigate to={pendingRoute} replace />;

  return (
    <>
      <Routes>
        <Route index element={<Navigate to={ROUTES.ORGANIZATIONS} replace />} />
        <Route path={ROUTES.ORGANIZATIONS + "/*"} element={<Organizations />} />
        <Route
          path="*"
          element={
            <NotFound
              buttonLabel="Go to Organizations"
              navigateTo={ROUTES.ORGANIZATIONS}
            />
          }
        />
      </Routes>
    </>
  );
}
